export default function localeCountry({ store }) {
  // do not set locale or country if has been set
  if (store.state.settings.countryUser) {
    return
  }

  store.dispatch('settings/getCountryUser')
}
